export default __webpack_public_path__ + "static/cht-4c9df03bc5c13573134e767ff55b4e66.png";